import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "stc_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) { /* ignore */ }
  }, []);

  const persist = (next) => {
    setItems(next);
    localStorage.setItem(KEY, JSON.stringify(next));
  };

  const addItem = useCallback((item) => {
    setItems((prev) => {
      // group identical lines (same artwork+variant+text)
      const idx = prev.findIndex(
        (p) =>
          p.artwork_id === item.artwork_id &&
          p.variant_key === item.variant_key &&
          (p.personal_text || "") === (item.personal_text || "")
      );
      let next;
      if (idx >= 0) {
        next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + item.quantity };
      } else {
        next = [...prev, item];
      }
      localStorage.setItem(KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const removeAt = (i) => {
    const next = items.filter((_, idx) => idx !== i);
    persist(next);
  };

  const setQty = (i, q) => {
    const next = items.map((it, idx) => idx === i ? { ...it, quantity: Math.max(1, q) } : it);
    persist(next);
  };

  const clear = () => persist([]);

  const count = items.reduce((s, it) => s + it.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeAt, setQty, clear, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
